module.exports = __webpack_public_path__ + "img/yellow.1472075a.gif";